import { fork, take, call, put, all } from "redux-saga/effects";

import {
  certificateDataResponse,
  getAllCertificationsResponse,
  getGlobalSearchCertificatesResponse,
  getPopularCertificationsResponse,
  getSingleCertificationsResponse,
} from "./actions";
import types from "./types";
import { postAPIWithoutModule } from "../../api/generic";

export function* doCertificate() {
  while (true) {
    const { payload } = yield take(types.CERTIFICATE_DATA);
    const response = yield call(postAPIWithoutModule, payload);
    // console.log("Certificate Saga", response);
    yield put(certificateDataResponse(response));
  }
}

export function* doGetAllCertifications() {
  while (true) {
    const { payload } = yield take(types.GET_ALL_CERTIFICATIONS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAllCertificationsResponse(response));
  }
}

export function* doGetSingleCertifications() {
  while (true) {
    const { payload } = yield take(types.GET_SINGLE_CERTIFICATIONS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getSingleCertificationsResponse(response));
  }
}

export function* doGetPopularCertifications() {
  while (true) {
    const { payload } = yield take(types.GET_POPULAR_CERTIFICATIONS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getPopularCertificationsResponse(response));
  }
}

export function* doGetGlobalSearchCertifications() {
  while (true) {
    const { payload } = yield take(types.GLOBAL_SEARCH_CERTIFICATES);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getGlobalSearchCertificatesResponse(response));
  }
}

function* certificateURL() {
  yield fork(doCertificate);
  yield fork(doGetAllCertifications);
  yield fork(doGetSingleCertifications);
  yield fork(doGetPopularCertifications);
  yield fork(doGetGlobalSearchCertifications)
}

export default certificateURL;
